import React from 'react';
import Immutable from 'immutable';

import { FormattedMessageHelper } from '../../../../shared/helpers/internationalization';
import { addModifiers } from '../../../../shared/helpers';

import './PasswordGuidelines.scss';

export interface PasswordGuideline {
  content: string;
  errorIntlId: string;
}

export const PASSWORD_GUIDELINES: PasswordGuideline[] = [
  { content: 'step1.password.guidelines.minimumLength', errorIntlId: 'field.password.minimumLength' },
  { content: 'step1.password.guidelines.notOnlyNumbers', errorIntlId: 'field.password.onlyNumeric' },
  { content: 'step1.password.guidelines.similarToUserAttributes', errorIntlId: 'field.password.similarUserAttributes' },
  { content: 'step1.password.guidelines.commonPassword', errorIntlId: 'field.password.commonPassword' },
];

export interface PasswordGuidelinesProps {
  password: string | undefined;
  validationErrors: Immutable.List<string> | undefined;
  guidelines?: PasswordGuideline[];
}

export function PasswordGuidelines({ password, validationErrors, guidelines = PASSWORD_GUIDELINES }: PasswordGuidelinesProps) {
  const isPasswordEmpty = !password || password.length === 0;

  function getIsGuidelineNotPassed(guideline: PasswordGuideline) {
    // All guidelines are not passed when password is empty
    return isPasswordEmpty || validationErrors?.find(error => error.startsWith(guideline.errorIntlId));
  }

  return (
    <div className="password-guidelines">
      <p className="password-guidelines__title">
        <FormattedMessageHelper id="step1.password.guidelines.mustHave" />
      </p>
      <ul className="password-guidelines__items">
        {guidelines.map((guideline, index) => {
          const isNotPassed = getIsGuidelineNotPassed(guideline);
          const modifiers = isNotPassed ? [] : ['PASSED'];
          return (
            <li key={index} className={addModifiers('password-guidelines__item', modifiers)}>
              <FormattedMessageHelper id={guideline.content} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
